module.exports = __webpack_public_path__ + "img/diseases.7a24a1f4.svg";